// src/controllers/sucursalController.js

import { getSucursales, createSucursal, updateSucursal, deleteSucursal } from '../models/sucursalModel';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchSucursales(page, perPage) {
  try {
    const response = await getSucursales(page, perPage);
    return {
      sucursal: response.items,
      totalRecords: response.totalItems,
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching sucursales:", error);
    Swal.fire('Error', 'No se pudieron cargar las sucursales', 'error');
    return null;
  }
}

export async function saveSucursal(sucursal, currentSucursalId) {
  try {
    if (currentSucursalId) {
      const result = await updateSucursal(currentSucursalId, sucursal);
      toasts.add({
        title: 'Éxito',
        description: 'Sucursal guardada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
      return result;
    } else {
      const result = await createSucursal(sucursal);
      toasts.add({
        title: 'Éxito',
        description: 'Sucursal creada exitosamente',
        duration: 3000, // Duración de 3 segundos
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
      return result;
    }
  } catch (error) {
    console.error("Error saving sucursal:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar la sucursal',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
    throw error;
  }
}

export async function removeSucursal(id) {
  try {
    await deleteSucursal(id);
    toasts.add({
      title: 'Éxito',
      description: 'Sucursal eliminada exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting sucursal:", error);
    Swal.fire('Error', 'No se pudo eliminar la sucursal', 'error');
  }
}

// Suscripción en tiempo real a cambios en la colección 'sucursal'
export function subscribeToSucursales(searchQuery, handleSearch) {
  pb.collection('sucursal').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(); // Actualiza la lista manteniendo la página actual
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromSucursales() {
  pb.collection('sucursal').unsubscribe('*');
}

export async function searchSucursales(query, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('sucursal').getList(page, perPage, {
      filter: `descrip ~ "${query}"`,
      $autoCancel: false
    });
    return {
      sucursal: response.items,
      totalRecords: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching sucursales:", error);
    throw error;
  }
}
